import api from '../api';

/**
 * Send a password reset request for a user based on their phone number.
 *
 * @param {string} phone - The user's phone number.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const sendPasswordReset = async (phone) => {
  const endpoint = process.env.REACT_APP_API_ENDPOINT + "/api/user/sendPasswordReset";

  try {
    const response = await api.post(endpoint, { phone });
    return response.data;
  } catch (error) {
    console.error('Error while sending password reset:', error);
    throw error;
  }
}

export default sendPasswordReset;
